export default "__VITE_ASSET__fb9595a8__"